import { Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import React from "react";

export const ModalAviso = ({
    titulo = 'Confirmação',
    conteudo = null,
    onOk = () => {},
    onCancel = () => {},
    okText = 'Sim',
    cancelText = 'Não',
    okType = 'primary'
}) => {
    Modal.confirm({
        title: titulo,
        icon: <ExclamationCircleFilled />,
        content: conteudo,
        okText: okText,
        cancelText: cancelText,
        okType: okType,
        centered: true,
        onOk() {
            onOk();
        },
        onCancel() {
            onCancel();
        },
    });
};